import React from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';

import TopPerformanceWidget from './TopPerformanceWidget';

const Container = styled('ul')`
  list-style: none;
  width: 100%;
  padding: 0;
`;

const TopPerformanceWidgetsContainer = () => {
  const topPrWidgets = useSelector((state) => state.feed.data.topPrWidgets);

  return (
    <Container>
      {topPrWidgets?.length > 0 && (
        topPrWidgets.map((topPrObject) => (
          <TopPerformanceWidget key={topPrObject.id} topPrObject={topPrObject} />
        ))
      )}
    </Container>
  );
};

export default TopPerformanceWidgetsContainer;
